const configured = import.meta.env.VITE_FUNCTIONS_BASE_URL as string | undefined;

if (import.meta.env.DEV && !configured) {
  console.warn(
    '[config] VITE_FUNCTIONS_BASE_URL is not set — Cloud Function calls will target the production endpoint.'
  );
}

export const functionsBaseUrl =
  configured ?? 'https://us-central1-everyday-a656c.cloudfunctions.net';
